let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7RRcE")).then(() => parcelRequire('2gnbS'));